import {createRouter,createWebHistory} from 'vue-router'
const routes = [
    {
        path: "/",
        redirect: '/login'
    },
    {
        path:"/login",
        component:() => import("../views/LoginView.vue")  
    },
    {
        path:'/register',
        component:() => import('../views/RegisterView.vue')
    },
    {
        path: "/shop/home",
        component:() => import("../views/ShopView.vue")
    },
    {
        path:'/shop/category',
        component:() => import("../views/CategoryViews.vue")
    },
    {
        path:'/shop/cart',
        component:() => import("../views/CartViews.vue")
    },
    {
        path:'/shop/profile',
        component:() => import("../views/ProfileVIews.vue")
    },
    {
        path:'/shop/product',
        component: () => import("../views/ProductViews.vue")
    },
    {
        path:'/profile/set',
        component: () => import("../views/SetViews.vue")
    },
    {
        path:'/shop/product/post',
        component: () => import("../views/PostProductViews.vue")
    },
    {
        path:'/shop/product/myproduct',
        component: () => import("../views/ShowProductViews.vue")
    },
    {
        path:'/shop/product/change',
        component: () => import("../views/ChangeProductViews.vue")
    },
    {
        path:'/shop/myorder',
        component: () => import("../views/MyOrder.vue")
    },
    {
        path:'/shop/mybalance',
        component: () => import("../views/MyBalance.vue")
    },
    {
        path:'/shop/search',
        component: () => import("../views/SearchViews.vue")
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router